let l10n = {
    en: {
        // Buttons
        saveBtn: 'Save',
        cancelBtn: 'Cancel',
        assessmentMultipleChoice: {
            header: 'Multiple Choice',
            title: 'Create Multiple Choice Assessment',
            question: 'Enter question for multiple choice',
            listOptions: 'List with options',
            choiceTitle: 'Enter choice title',
            saveBtn: 'Save',
            errorMessage: 'Please choose the answer',
            errorMessage2: 'Please select at least one answer',
            hint: 'Select the correct answer',
        },
        assessmentMultipleResponse: {
            header: 'Multiple Response',
            title: 'Create Multiple Response Assessment',
            question: 'Enter question for multiple response',
            listOptions: 'List with options',
            choiceTitle: 'Enter choice title',
            saveBtn: 'Save',
            errorMessage: 'Please choose one or more the answers',
            selectAllThatApply: 'Select ALL That Apply',
            hint: 'Select ALL the correct answers',
        },
        assessmentMatching: {
            header: 'Matching',
            title: 'Create Matching Assessment',
            question: 'Enter question for matching',
            listOptions: 'List with matches',
            choiceTitle: 'Enter choice title',
            matchTitle: 'Enter match title',
            saveBtn: 'Save',
            errorMessage: 'Please match all items',
            hint: 'Drag each item to its correct pair',
        },
        assessmentSequence: {
            header: 'Sequence',
            title: 'Create Sequence Assessment',
            question: 'Enter question for sequence',
            listOptions: 'List with sequence',
            itemTitle: 'Enter item title',
            saveBtn: 'Save',
            hint: 'Drag the boxes in the correct order',
        },
        assessmentShortAnswer: {
            header: 'Short Answer',
            title: 'Create Short Answer Assessment',
            question: 'Enter question',
            inputAnswer: 'Enter short answer',
            answer: 'Short answer',
        },
        assessmentHotspotImage: {
            header: 'Hotspot Image',
            title: 'Create Hotspot Image Assessment',
            question: 'Enter question',
            addImage: 'Add image',
        },
        assessmentsCommon: {
            errorMessageForEmptyQuestion: 'Question must be not empty',
            errorMessageForOneOption: 'Fill at least two options',
            errorMessageForNotUniqueOption: 'Option must be unique',
            errorMessageFillBothPartMatching: 'Fill both parts of matching',
            errorMessageForOneMatches: 'Fill at least two matches',
        },

        // Create custom course
        customCourse: {
            editOutline: 'Edit outline',
            exitEditing: 'Exit editing',
            preview: 'Preview',
            edit: 'Edit',
            remove: 'Delete',
            sameAsPre: 'Same as PRE',
            multipleChoice: 'Multiple choice',
            matching: 'Matching',
            imageHotspot: 'Image hotspot',
            sequence: 'Sequence',
            shortAnswer: 'Short answer',
            multipleResponse: 'Multiple response',
            addQuestion: 'Add question',
            addLesson: 'Add lesson',
            previewPreAssessment: 'Preview Pre-Assessment',
            previewTutorial: 'Preview Tutorial',
            previewPostAssessment: 'Preview Post-Assessment',
            addSkill: 'Add Skill',
            addTutorial: 'Add tutorial',
            correctStatus: 'Correct',
            wrongStatus: 'Incorrect',
            takeTutorial: 'Take tutorial',
            answers: 'answers',
            your: 'Your',
            choices: 'Choices',
            iDontKnow: 'I Don\'t Know',
            submit: 'Submit',
            enterModuleName: 'Enter module name',
            newModule: 'New module',
            aiAssistant: 'AI assistant',
            uploading: 'Uploading',
            textLesson: 'Text lesson',
            correctAnswer: 'Correct answer',
            correctSequence: 'Correct sequence',
            correctMatching: 'Correct matching pairs',
            answer: 'Answer',
            courseName: 'Course Name',
            lessonBuilder: 'Lesson Builder',
        },
        questionsList: {
            'multiple_choice': 'Multiple choice',
            'multiple_response': 'Multiple response',
            'matching': 'Matching',
            'sequence': 'Sequence',
            // 'short_answer': 'Short answer',
            // 'image_hotspot': 'Image hotspot',
        },
        lessonsList: {

            'cgeditor': 'Lesson builder',
            'existing_lesson': 'Existing Lesson',
            //'cgeditor_ai': 'Lesson builder AI',
            // 'cgeditor_ai_2': 'Lesson builder AI 2',
            // 'cgeditor_ai_3': 'Lesson builder AI 3',
            'video': 'Video',
            'document': 'Document',
           // 'scorm_upload': 'SCORM upload',
            'external_link': 'External Link',
        },
        lessonText: {
            'existing_add_btn': 'Add lesson to course',
            'video_popup_title': 'Add video lesson',
            'document_popup_title': 'Add document lesson',
            'scorm_popup_title': 'Add SCORM lesson',
            'video_save_btn': 'Save and add video to lesson',
            'video_embed_placeholder': 'PLease add URL to video',
            'video_embed_label': 'Add URL to video',
            'video_embed_bottom_text': 'Add URL to video on YouTube or Vimeo.',
            'video_embed_error': 'Please add valid URL to video',
            'video_file_btn': 'Upload video file',
            'video_btn_under': `Add file in mp4, ogg, mov, webm, wmv. <br> File size not more than 500Mb`,
            'video_or': 'or',
            'video_wrong_url': 'Invalid URL. Please enter a valid YouTube or Vimeo URL',
            'video_upload_error': 'Error uploading video',
            'external_popup_title': 'Add external link lesson',
            'external_btn': 'Save and add website link to lesson',
        },
        moveActions: {
            'up': 'Move Up',
            'down': 'Move Down',
            'delete': 'Delete',
        },
        lessonNew: {
            'custom': 'New Skill',
            'existing': 'Existing Skill',
        },
        moduleNew: {
            'create': 'Create Module',
            'existing': 'Existing Module',
            'existing_course': 'Existing Course',
        },
        sessionNew: {
           // 'create_session': 'Create Session',
            'create': 'Create Module',
            'existing': 'Existing Module',
            'existing_course': 'Existing Course',
        },
        moduleTypeList: {
            '1': 'Verified Learning',
            '2': 'Skills Gaps',
            '3': 'Assessment',
            '4': 'Practice Test',
            '5': 'Lessons Only',
        },
        catalog: {
            quickReference: 'cheat sheet',
            course: 'course',
            quickReferences: 'Cheat Sheets',
            courses: 'Courses',
            topics: 'Topics',
            noMatchingRecordFound: 'No matching record found',
            selfEnrolled: 'Self Enrolled',
            selfAssigned: 'Self Assigned',
            enrolledBy: 'Enrolled By',
            started: 'Started',
            lastAccess: 'Last Access',
            completed: 'Completed',
            labelImprovement: 'Improvement',
            assignmentFrom: 'Assignment From',
            assigned: 'Assigned',
            messageNoDataFound: 'No data found',
            assignedBy: 'Assigned By',
            owner: 'Owner',
            user: 'user',
            users: 'users',
            progress: 'Progress',
            preAssess: 'Pre-Assess',
            postAssess: 'Post-Assess',
            improve: 'Improve',
            noModulesCompletedMsg: 'No Modules Completed',
            you: 'You',
            included: 'included',
            minutes: 'minutes',
            assignment: 'assignment',
            assignments: 'assignments'
        },
        textTopicResultNotification: {
            preAssessment: 'Pre-Assessment',
            postAssessment: 'Post-Assessment',
            quickAnswer: 'Quick Answer:',
            incorrect: 'Incorrect',
            correct: 'Correct',
            tryAgain: 'Try Again',
            retakeTutorial: 'Retake Tutorial',
            next: 'Next',
            fail: 'Fail',
            pass: 'Pass',
            complete: 'Complete',
            started: 'Started',
            incomplete: 'Incomplete',
            notStarted: 'Not Started',
            skip: 'Skip',
            startLesson: 'Start Lesson',
            close: 'Close',
            preAssessmentSubtitle: 'See if you already know this',
            postAssessmentSubtitle: 'Verify you’ve mastered this',
            takeLesson: 'Take Lesson',
            submitAnswer: 'Submit Answer',
        },
        pricePage: {
            billedAnnually: 'billed annually',
            billedMonthly: 'billed monthly',
        },
        popupClass: {
            goToNextImage: 'Go to next image',
            goToPreviousImage: 'Go to previous image',
        },
        aiAssistant: {
            createLesson: 'Create Lesson',
            aiAssistedContent: 'AI-Assisted Content',
            lessonNameLabel: 'Lesson name',
            addLessonName: 'Please add lesson name',
            additionalInstructions: 'Additional Instructions for assistant',
            promptHint: 'Additional instructions, approximate course length, tone, audience. Please keep it SHORT',
            proposedLesson: 'Proposed Lesson',
            adjustInputs: 'Adjust inputs',
            commitLesson: 'Commit Lesson',
            errorMessage1: 'Sorry, something went wrong... Please try again later.',
            errorMessage2: 'Sorry, something went wrong while processing the data... Please try again later.',
            errorMessage3: 'Sorry, something unexpected happened... Please try again later.',
            errorMessage4: 'Please add course name',
        },
        learningModeDropdown: {
            learningMode: 'Learning mode',
            preAssess: 'Pre-assess',
            lesson: 'Lesson',
            postAssess: 'Post-assess',
            verifiedLearning: 'Verified Learning',
            requireSkill: 'Require skill proficiency',
            required: 'Required',
            assessment: 'Assessment',
            measureSkills: 'Measure existing skills',
            skillGaps: 'Skill Gaps',
            addressSkill: 'Address skill deficiencies',
            optionalIfProficient: 'Optional if Proficient',
            practiceTest: 'Practice Test',
            certificationStudy: 'Certification study',
            lessonOnly: 'Lessons Only',
            noSkillAssessments: 'No skill assessments',
            resetProgress: 'Reset Progress',
        },
        forms: {
            getQuoteMessage: 'Thank you for your request. We will contact you shortly',
            useWorkEmail: 'Please use work email instead personal',
        },
        unsplash: {
            searchImage: 'Search image',
            loadMore: 'Load more',
        },
        editor: {
            edit: 'Edit',
            remove: 'Delete',
            addTitle: 'Add a title',
            addImage: 'Add image',
            addNewItem: 'Add new item',
            enterQuestion: 'Enter question',
            questionLabel: 'Question',
            enterText: 'Enter text',
            isCorrect: 'Is correct',
            submit: 'Submit',
            addText: 'Add text',
            text: 'Text',
            image: 'Image',
            enterCaption: 'Enter caption',
            addNewImage: 'Add new image',
            heading: 'Heading',
            imageCaption: 'Image caption (optional)',
            deleteThisBlock: 'Are you sure you want to delete this block',
            yes: 'Yes',
            removeMarker: 'Remove marker',
            previous: 'Previous',
            next: 'Next',
            labelTitle: 'Label title',
            labelDescription: 'Label description',
            settings: 'Settings',
            moveBlockUp: 'Move block Up',
            moveUp: 'Move Up',
            moveBlockDown: 'Move block Down',
            moveDown: 'Move Down',
            cloneBlock: 'Clone block',
            clone: 'Clone',
            deleteBlock: 'Delete block',
            labeledImage: 'Labeled Image',
            list: 'List',
            paragraph: 'Paragraph',
            sortingActivity: 'Sorting Activity',
            statement: 'Statement',
            twoColumns: 'Two Columns',
            divider: 'Divider',
            accordion: 'Accordion',
            table: 'Table',
            imageText: 'Image Text',
            timeline: 'Timeline',
            gallery: 'Gallery',
            flashCard: 'Flashcard',
            matching: 'Matching',
            sorting: 'Sorting',
            choice: 'Choice',
            tabs: 'Tabs',
            addCard: 'Add card',
            enterCardText: 'Enter card text',
            deleteCard: 'Delete card',
            noCardsAdded: 'No cards added',
            replay: 'Replay',
            item: 'Item',
            column: 'Column',
            tabTitle: 'Tab title',
            enterTitle: 'Enter title',
            addSubheading: 'Add subheading',
            addHeading: 'Add heading',
            date: 'Date',
            addNewLabel: 'Add new label',
            labelSettings: 'Labels settings',
            layoutSettings: 'Layout settings',
            imageSettings: 'Image settings',
            uploadImage: 'Upload image',
            editImage: 'Edit image',
            caption: 'Caption',
            altText: 'Alt text',
            addCardTitle: 'Add card title',
            addSectionTitle: 'Add section title',
            sortingActivitySettings: 'Sorting Activity Settings',
            addCategory: 'Add category',
            changeImage: 'Change image',
            imageFromLibrary: 'Image from library',
            imageCaptionSetting: 'Image Caption',
            cutImage: 'Cut image',
            changeLayout: 'Change Layout',
            addLabel: 'Add label',
            changeImageDimension: 'Change image dimension',
            previewMode: 'Preview mode',
            fileSizeTooBig: 'File size is too big. Max file size is 10 mb',
            imageAlt: 'Image alt',
            apply: 'Apply',
            loading: 'Loading',
            wantSaveChanges: 'Do you want to save changes before close?',
            yesISaveIt: 'Yes, save it',
            noDontSave: 'No, don\'t save',
            savingProcess: 'Saving process',
            saved: 'Saved',
            saveLesson: 'Save lesson',
        },
        courseManagement: {
            publishCourse: 'Publish Course',
            cloneCourse: 'Clone Course',
            archiveCourse: 'Archive Course',
            deleteCourse: 'Delete Course'
        },
        settings: {
            msgLogoRemoved: 'The account logo has been removed.',
            errorAccountName: 'Account name can\'t be empty',
            errorAccountTheme: 'Please add a valid value (6-digit hex code)',
            errorNotAllowedSymbols: 'Special characters is not allowed',
            errorSpacesNotAllowed: 'Spaces is not allowed'
        },
        assignments: {
            day: 'day',
            days: 'days',
            multiple: 'Multiple',
            add: 'Add',
            dueDate: 'Due Date'
        },
        pagination: {
            showing: 'Showing',
            of: 'of'
        },
        userPanel: {
            firstNameErrorMsg: 'First name can\'t be empty.',
            lastNameErrorMsg: 'Last name can\'t be empty.',
            emailErrorMsg: 'Please enter a valid email address.',
            phoneErrorMsg: 'Phone number is not valid. Please add at least 10 digits. Special characters are not allowed.'
        },
        transferTrialUsers: {
            userAlreadyOnTheListMsg: 'This user is already on the list.',
            userTransferFailedMsg: 'User Transfer failed. Please try again.'
        }
    },
    es: {
        // Buttons
        saveBtn: 'Ahorrar',
        cancelBtn: 'Cancelar',
        assessmentMultipleChoice: {
            header: 'Opción multiple',
            title: 'Crear evaluación de opción múltiple',
            question: 'Ingrese la pregunta para la opción múltiple',
            listOptions: 'Lista con opciones',
            choiceTitle: 'Ingrese el título de la opción',
            saveBtn: 'Ahorrar',
            errorMessage: 'Por favor elige la respuesta',
            errorMessage2: 'Por favor seleccione al menos una respuesta',
            hint: 'Selecciona la respuesta correcta',
        },
        assessmentMultipleResponse: {
            header: 'Respuesta múltiple',
            title: 'Crear evaluación de respuesta múltiple',
            question: 'Ingrese la pregunta para la respuesta múltiple',
            listOptions: 'Lista con opciones',
            choiceTitle: 'Ingrese el título de la opción',
            saveBtn: 'Ahorrar',
            errorMessage: 'Por favor elija una o más respuestas',
            selectAllThatApply: 'Seleccione todas las que correspondan',
            hint: 'Seleccione TODAS las respuestas correctas',
        },
        assessmentMatching: {
            header: 'Pareo',
            title: 'Crear evaluación de coincidencia',
            question: 'Ingrese la pregunta para la coincidencia',
            listOptions: 'Lista con coincidencias',
            choiceTitle: 'Ingrese el título de la opción',
            matchTitle: 'Introduce el título del partido',
            saveBtn: 'Ahorrar',
            errorMessage: 'Por favor haga coincidir todos los elementos',
            hint: 'Arrastre cada elemento a su par correcto',
        },
        assessmentSequence: {
            header: 'Secuencia',
            title: 'Crear evaluación de secuencia',
            question: 'Ingrese la pregunta para la secuencia',
            listOptions: 'Lista con secuencia',
            itemTitle: 'Introduzca el título del artículo',
            saveBtn: 'Ahorrar',
            hint: 'Arrastra las cajas en el orden correcto',
        },
        assessmentShortAnswer: {
            header: 'Respuesta corta',
            title: 'Crear evaluación de respuesta corta',
            question: 'Introducir pregunta',
            inputAnswer: 'Introduzca una respuesta corta',
            answer: 'Respuesta corta',
        },
        assessmentHotspotImage: {
            header: 'Imagen de punto de acceso',
            title: 'Crear evaluación de imagen de punto de acceso',
            question: 'Introducir pregunta',
            addImage: 'Añadir imagen',
        },
        assessmentsCommon: {
            errorMessageForEmptyQuestion: 'La pregunta no debe estar vacía',
            errorMessageForOneOption: 'Complete al menos dos opciones',
            errorMessageForNotUniqueOption: 'La opción debe ser única',
            errorMessageFillBothPartMatching: 'Rellene ambas partes de la correspondencia',
            errorMessageForOneMatches: 'Rellene al menos dos coincidencias',
        },

        // Create custom course
        customCourse: {
            editOutline: 'Editar esquema',
            exitEditing: 'Salir de la edición',
            preview: 'Avance',
            edit: 'Editar',
            remove: 'Eliminar',
            sameAsPre: 'Lo mismo que PRE',
            multipleChoice: 'Opción multiple',
            matching: 'Pareo',
            imageHotspot: 'Punto de acceso de imagen',
            sequence: 'Secuencia',
            shortAnswer: 'Respuesta corta',
            multipleResponse: 'Respuesta múltiple',
            addQuestion: 'Agregar pregunta',
            addLesson: 'Agregar lección',
            previewPreAssessment: 'Vista previa de la evaluación previa',
            previewTutorial: 'Tutorial de vista previa',
            previewPostAssessment: 'Vista previa de la evaluación posterior',
            addSkill: 'Agregar habilidad',
            addTutorial: 'Agregar tutorial',
            correctStatus: 'Correcta',
            wrongStatus: 'Incorrecta',
            takeTutorial: 'Tomar tutorial',
            answers: 'respuestas',
            your: 'Su',
            choices: 'Opciones',
            iDontKnow: 'No Sé',
            submit: 'Entregar',
            enterModuleName: 'Introduzca el nombre del módulo',
            newModule: 'Nuevo módulo',
            aiAssistant: 'Asistente de IA',
            uploading: 'Subiendo',
            textLesson: 'Lección de texto',
            correctAnswer: 'Respuesta correcta',
            correctSequence: 'Secuencia correcta',
            correctMatching: 'Corregir pares coincidentes',
            answer: 'Respuesta',
            courseName: 'Nombre del curso',
            lessonBuilder: 'Constructor de lecciones',
        },
        questionsList: {
            'multiple_choice': 'Opción multiple',
            'multiple_response': 'Respuesta múltiple',
            'matching': 'Pareo',
            'sequence': 'Secuencia',
            // 'short_answer': 'Respuesta corta',
            // 'image_hotspot': 'Punto de acceso de imagen',
        },
        lessonsList: {
            'cgeditor': 'Página',
            'video': 'Video upload',
            'document': 'Document Upload',
            //'scorm_upload': 'SCORM upload',
            'video_upload': 'Video Upload',
            'existing_lesson': 'Existing Lesson',
        },
        lessonText: {
            'existing_add_btn': 'Agregar lección al curso',
            'video_popup_title': 'Agregar lección de video',
            'document_popup_title': 'Agregar lección de documento',
            'scorm_popup_title': 'Agregar lección SCORM',
            'video_save_btn': 'Agregar video a la lección',
            'video_embed_placeholder': 'Agregue la URL del video',
            'video_embed_bottom_text': 'Agregue la URL del video en YouTube o Vimeo.',
            'video_embed_error': 'Agregue una URL válida al video',
            'video_file_btn': 'Subir archivo de video',
            'video_btn_under': 'Agregue un archivo en mp4, ogg, mov, webm, wmv. \/n Tamaño de archivo no superior a 500Mb',
        },
        moveActions: {
            'up': 'Ascender',
            'down': 'Mover hacia abajo',
            'delete': 'Borrar',
        },
        lessonNew: {
            'custom': 'Nueva habilidad',
            'existing': 'Habilidad existente',
        },
        moduleNew: {
            'create': 'Crear módulo',
            'existing': 'Módulo existente',
            'existing_course': 'Curso existente',
        },
        sessionNew: {
            'create_session': 'Crear sesión',
            //'create': 'Crear módulo',
            'existing': 'Módulo existente',
            'existing_course': 'Curso existente',
        },
        moduleTypeList: {
            '1': 'Aprendizaje verificado',
            '2': 'Brechas de habilidades',
            '3': 'Evaluación',
            '4': 'Examen de práctica',
            '5': 'Solo lecciones',
        },
        catalog: {
            quickReference: 'referencia rápida',
            course: 'curso',
            quickReferences: 'Referencias rápidas',
            courses: 'Cursos',
            topics: 'Temas',
            noMatchingRecordFound: 'No se encontró ningún registro coincidente',
            selfEnrolled: 'Auto inscrito',
            selfAssigned: 'Auto asignado',
            enrolledBy: 'Inscrito por',
            started: 'Empezado',
            lastAccess: 'Último acceso',
            completed: 'Terminado',
            labelImprovement: 'Mejoría',
            assignmentFrom: 'Asignación de',
            assigned: 'Asignado',
            messageNoDataFound: '¡Datos no encontrados',
            assignedBy: 'Asignado por',
            owner: 'Dueño',
            user: 'usuario',
            users: 'usuarios',
            progress: 'Progreso',
            preAssess: 'Evaluación previa',
            postAssess: 'Evaluación posterior',
            improve: 'Mejorar',
            noModulesCompletedMsg: 'No hay módulos completados',
            you: 'Tú',
            included: 'incluida',
            minutes: 'minutos',
            assignment: 'asignación',
            assignments: 'asignaciones'
        },
        textTopicResultNotification: {
            preAssessment: 'Pre-Evaluación',
            postAssessment: 'Evaluación Posterior',
            quickAnswer: 'Respuesta rápida:',
            incorrect: 'Incorrecto',
            correct: 'Correcto',
            tryAgain: 'Inténtalo de nuevo',
            retakeTutorial: 'Volver a Tutorial',
            next: 'Siguiente',
            fail: 'No Aprobado',
            pass: 'Aprobado',
            complete: 'Completo',
            started: 'Empezado',
            incomplete: 'Incompleto',
            notStarted: 'No empezado',
            skip: 'Omitido',
            startLesson: 'Iniciar lección',
            close: 'Cerca',
            preAssessmentSubtitle: 'A ver si ya lo sabes',
            postAssessmentSubtitle: 'Verifica que dominas esto',
            takeLesson: 'Tomar Lección',
            submitAnswer: 'Enviar Respuesta',
        },
        pricePage: {
            billedAnnually: 'facturado anualmente',
            billedMonthly: 'facturado mensualmente',
        },
        popupClass: {
            goToNextImage: 'Ir a la siguiente imagen',
            goToPreviousImage: 'Ir a la imagen anterior',
        },
        aiAssistant: {
            createLesson: 'Crear lección',
            aiAssistedContent: 'Contenido asistido por IA',
            lessonName: 'Nombre de la lección',
            addLessonName: 'Por favor agregue el nombre de la lección',
            additionalInstructions: 'Instrucciones adicionales para asistente',
            promptHint: 'Instrucciones adicionales, duración aproximada del curso, tono, audiencia. Por favor, sea BREVE',
            proposedLesson: 'Lección propuesta',
            adjustInputs: 'Ajustar entradas',
            commitLesson: 'Lección de compromiso',
            errorMessage1: 'Lo sentimos, algo salió mal... Por favor, inténtalo de nuevo más tarde.',
            errorMessage2: 'Lo sentimos, algo salió mal al procesar los datos... Por favor, inténtalo de nuevo más tarde.',
            errorMessage3: 'Lo sentimos, ocurrió algo inesperado... Por favor, inténtalo de nuevo más tarde.',
            errorMessage4: 'Por favor agregue el nombre del curso',
        },
        learningModeDropdown: {
            learningMode: 'Modo de aprendizaje',
            preAssess: 'Pre-evaluación',
            lesson: 'Lección',
            postAssess: 'Evaluación posterior',
            verifiedLearning: 'Aprendizaje verificado',
            requireSkill: 'Requiere dominio de habilidades',
            required: 'Requerida',
            assessment: 'Evaluación',
            measureSkills: 'Medir las habilidades existentes',
            skillGaps: 'Brechas de habilidades',
            addressSkill: 'Abordar las deficiencias de habilidades',
            optionalIfProficient: 'Opcional si es competente',
            practiceTest: 'Examen de práctica',
            certificationStudy: 'Estudio de certificación',
            lessonOnly: 'Solo lecciones',
            noSkillAssessments: 'Sin evaluaciones de habilidades',
            resetProgress: 'Restablecer progreso',
        },
        forms: {
            getQuoteMessage: 'Gracias por tu solicitud. Nos comunicaremos contigo en breve',
            useWorkEmail: 'Utilice el correo electrónico del trabajo en lugar del personal',
        },
        unsplash: {
            searchImage: 'Buscar imagen',
            loadMore: 'Carga más',
        },
        editor: {
            edit: 'Editar',
            remove: 'Borrar',
            addTitle: 'Añade un titulo',
            addImage: 'Añadir imagen',
            addNewItem: 'Agregar ítem nuevo',
            enterQuestion: 'Introducir pregunta',
            questionLabel: 'Pregunta',
            enterText: 'Ingrese texto',
            isCorrect: 'Es correcta',
            submit: 'Entregar',
            addText: 'Añadir texto',
            text: 'Texto',
            image: 'Imagen',
            enterCaption: 'Ingresar subtítulo',
            addNewImage: 'Agregar nueva imagen',
            heading: 'Título',
            imageCaption: 'Título de imagen (opcional)',
            deleteThisBlock: '¿Estás seguro de que quieres eliminar este bloque',
            yes: 'Sí',
            removeMarker: 'Quitar marcador',
            previous: 'Previa',
            next: 'Próxima',
            labelTitle: 'Título de la etiqueta',
            labelDescription: 'Descripción de la etiqueta',
            settings: 'Ajustes',
            moveBlockUp: 'Mover bloque hacia arriba',
            moveUp: 'Ascender',
            moveBlockDown: 'Mover bloque hacia abajo',
            moveDown: 'Mover hacia abajo',
            cloneBlock: 'Clonar bloque',
            clone: 'Clon',
            deleteBlock: 'Eliminar bloque',
            labeledImage: 'Imagen etiquetada',
            list: 'Lista',
            paragraph: 'Párrafo',
            sortingActivity: 'Actividad de clasificación',
            statement: 'Declaración',
            twoColumns: 'Dos columnas',
            divider: 'Divisor',
            accordion: 'Acordeón',
            table: 'Mesa',
            imageText: 'Texto de la imagen',
            timeline: 'Línea de tiempo',
            gallery: 'Galería',
            flashCard: 'Tarjeta de memoria flash',
            matching: 'Pareo',
            sorting: 'Clasificación',
            choice: 'Elección',
            tabs: 'Pestañas',
            addCard: 'Agregar tarjeta',
            enterCardText: 'Introduce el texto de la tarjeta',
            deleteCard: 'Eliminar tarjeta',
            noCardsAdded: 'No se agregaron tarjetas',
            replay: 'Repetición',
            item: 'Artículo',
            column: 'Columna',
            tabTitle: 'Título de la pestaña',
            enterTitle: 'Introduce el título',
            addSubheading: 'Añadir subtítulo',
            addHeading: 'Agregar encabezado',
            date: 'Fecha',
            addNewLabel: 'Agregar nueva etiqueta',
            labelSettings: 'Configuración de etiquetas',
            layoutSettings: 'Opciones de diseño',
            imageSettings: 'Configuración de imagen',
            uploadImage: 'Cargar imagen',
            editImage: 'Editar imagen',
            caption: 'Subtítulo',
            altText: 'Texto alternativo',
            addCardTitle: 'Agregar título de tarjeta',
            addSectionTitle: 'Agregar título de sección',
            sortingActivitySettings: 'Ordenar la configuración de actividad',
            addCategory: 'Añadir categoría',
            changeImage: 'Cambiar imagen',
            imageFromLibrary: 'Imagen de la biblioteca',
            imageCaptionSetting: 'Captura de imagen',
            cutImage: 'Cortar imagen',
            changeLayout: 'Cambia el diseño',
            addLabel: 'Agregar etiqueta',
            changeImageDimension: 'Cambiar dimensión de imagen',
            previewMode: 'Modo de vista previa',
            fileSizeTooBig: 'El tamaño del archivo es demasiado grande. El tamaño máximo del archivo es 10 mb',
            imageAlt: 'Imagen alternativa',
            apply: 'Aplicar',
            loading: 'Cargando',
            wantSaveChanges: '¿Quieres guardar los cambios antes de cerrar',
            yesISaveIt: 'Si, guárdalo',
            noDontSave: 'No, no guardes',
            savingProcess: 'Proceso de ahorro',
            saved: 'Salvado',
            saveLesson: 'Guardar lección',
        },
        courseManagement: {
            publishCourse: 'Publicar curso',
            cloneCourse: 'Curso de clonación',
            archiveCourse: 'Curso de archivo',
            deleteCourse: 'Eliminar curso'
        },
        settings: {
            msgLogoRemoved: 'Se ha eliminado el logotipo de la cuenta.',
            errorAccountName: 'El nombre de la cuenta no puede estar vacío',
            errorAccountTheme: 'Agregue un valor válido (código hexadecimal de 6 dígitos)',
            errorNotAllowedSymbols: 'No se permiten caracteres especiales',
            errorSpacesNotAllowed: 'No se permiten espacios'
        },
        assignments: {
            day: 'día',
            days: 'días',
            multiple: 'Múltiple',
            add: 'Agregar',
            dueDate: 'Dos citas'
        },
        pagination: {
            showing: 'Demostración',
            of: 'de'
        },
        userPanel: {
            firstNameErrorMsg: 'El nombre no puede estar vacío.',
            lastNameErrorMsg: 'El apellido no puede estar vacío.',
            emailErrorMsg: 'Por favor, introduce una dirección de correo electrónico válida.',
            phoneErrorMsg: 'El número de teléfono no es válido. Por favor, añada al menos 10 dígitos. No se permiten caracteres especiales.'
        },
        transferTrialUsers: {
            userAlreadyOnTheListMsg: 'Este usuario ya está en la lista.',
            userTransferFailedMsg: 'Error en la transferencia de usuario. Inténtalo de nuevo.'
        }
    },
};

const siteCodeLang = document.documentElement.lang;
l10n = (typeof siteCodeLang !== 'undefined') ? l10n[siteCodeLang] : l10n.en;

export default l10n;
